<script lang="ts">
  import { defineComponent } from "vue";
  import SectionSalarieRibAbstract from '@/generated/sections/SectionSalarieRibAbstract.vue';
  export default defineComponent({
    extends: SectionSalarieRibAbstract,
    components: {}
  })
</script>
